import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { addCustomPantryItem } from './pantry.service'
import { showToast } from '@/shared/utils/toast'
import type { AddCustomPantryItemRequest } from './types'

export function useAddCustomItem() {
  const queryClient = useQueryClient()
  const { t } = useTranslation('pantry')

  return useMutation({
    mutationFn: (req: AddCustomPantryItemRequest) => addCustomPantryItem(req),
    onSuccess: () => {
      showToast(t('essentials.addSuccess'))
      queryClient.invalidateQueries({ queryKey: ['pantry', 'ingredients'] })
    },
  })
}
